// filepath: /Users/paulojustinchan/Downloads/workspace/PriveMD/achieve-admin-frontend/src/pages/NotFound.js
import React from "react";
import { Box, Container, Typography } from "@mui/material";
import LargeLogo from "../components/LargeLogo/LargeLogo";

export default function NotFound({ theme }) {
    return (
        <Container
            sx={{
                backgroundColor: theme.palette.backgroundColor.main,
                height: "100vh",
                pt: 5,
                maxWidth: "100% !important",
            }}
        >
            <Box sx={{ color: "white" }}>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Box sx={{ width: { xs: "100%", md: "400px" } }}>
                        <LargeLogo />
                    </Box>
                </Box>

                <Typography
                    variant="h4"
                    component="h1"
                    gutterBottom
                    sx={{ textAlign: "center", mt: 5 }}
                >
                    404 - Page Not Found
                </Typography>

                <Typography variant="body1" sx={{ textAlign: "center" }}>
                    The page you are looking for does not exist.
                </Typography>
            </Box>
        </Container>
    );
}
